import { useParams, Link } from 'react-router-dom';
import { getArtworkById } from '../../data/artworks';
import NotFoundPage from '../NotFoundPage/NotFoundPage';
import styles from './ArtworkPage.module.css';

function ArtworkPage() {
  const { id } = useParams();
  const artwork = getArtworkById(id);

  if (!artwork) {
    return <NotFoundPage />;
  }

  return (
    <div className={styles.container}>
      <Link to="/" className={styles.backLink}>&larr; Back to Gallery</Link>
      <div className={styles.content}>
        <div className={styles.imageWrapper}>
          {artwork.image ? (
            <img src={artwork.image} alt={artwork.title} className={styles.image} />
          ) : (
            <div className={styles.placeholder}>{artwork.title.charAt(0)}</div>
          )}
        </div>
        <div className={styles.details}>
          <h1 className={styles.title}>{artwork.title}</h1>
          <p className={styles.description}>{artwork.description}</p>
          <div className={styles.meta}>
            <span><span className={styles.metaLabel}>Medium:</span> {artwork.medium}</span>
            <span><span className={styles.metaLabel}>Size:</span> {artwork.size}</span>
          </div>
          <div className={styles.price}>${artwork.price}</div>
          <a
            href={artwork.stripePaymentLink}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.buyButton}
          >
            Buy This Artwork
          </a>
        </div>
      </div>
    </div>
  );
}

export default ArtworkPage;
